import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Header from "../components/header"
import "../css/style.css"
import { RouterProps } from "@reach/router"
import { HeaderNavigation } from "../components/header-navigation"
import "typeface-source-sans-pro"
import Footer from "../components/footer"
import UmrFooter from "../components/umr-footer"

type LayoutProps = {
  children: React.ReactNode & RouterProps
  className: String
}

const Layout: React.FC<LayoutProps> = ({
  children,
  className,
  containerClass,
}) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div class={`bg-white-100 font-sans`}>
      <div class="flex flex-col min-h-screen">
        <div class="shadow-lg z-40">
          <Header siteTitle={data.site.siteMetadata.title} />
          <HeaderNavigation />
        </div>
        <div
          class={`flex-1 flex-col h-full mx-auto w-full max-w-4xl bg-white z-20 ${containerClass}`}
        >
          <main
            class={`h-full p-4 mt-8 text-blue-900 text-umr-grey-900 ${className}`}
          >
            {children}
          </main>
        </div>
        <div class="mt-12 shadow-lg z-40">
          <Footer />
        </div>
      </div>
      <UmrFooter />
    </div>
  )
}

export default Layout
